import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/dashboard/header";
import Footer from "../../../components/dashboard/footer";
import SideMenu from "../../student/SideMenu";
import { contentContext } from "../../../context/contentContext";
import SessionPopup from "../../SessionPopup";

let { lambda, appname } = window.app;

export default function AdminBiopsyList() {
    const navigate = useNavigate();
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const { GetTimeActivity } = useContext(contentContext);

    useEffect(() => {
        if (!localStorage.getItem("token")) navigate("/");
    }, []);

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <div className="main-content user-management" id="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">Biopsy Cases — Admin</h4>
                                        </div>
                                        <button className="create-quiz-btn border-0" onClick={() => navigate("/biopsy/cases/new")}>
                                            ADD
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body p-4">
                                            {/* Admin case list — all cases with Case Type badge — to be implemented */}
                                            <p className="text-muted">Admin biopsy case list coming soon.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
}
